import { dataFullCircle } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFullCircle = /*#__PURE__*/createIcon(dataFullCircle)
export default IconFullCircle
